import type { ResolvedNavEntry } from '../modules';
import { getNavEntries } from '../modules';

/** Shell-owned nav entry (settings) — not a feature module, so it doesn't live in the
 * registry, but it renders alongside module entries in the same nav. It carries a
 * `moduleId` anyway so `NavIcon` can resolve a drawn gear for it exactly like a real
 * module's icon. `/install` keeps its own route (linked from Settings and the install
 * banner) but, as of 2026-07-31, no longer takes a nav slot of its own (docs/DECISIONS.md). */
const SHELL_NAV_ENTRIES: ResolvedNavEntry[] = [
  { moduleId: 'settings', label: 'Settings', path: '/settings', icon: '⚙️', order: 910 },
];

/** Full nav list the chrome renders: module entries (registry-driven, tolerates 0–6+
 * entries per DESIGN-BRIEF §3.2) plus the shell's own Install/Settings entries. */
export function getChromeNavEntries(): ResolvedNavEntry[] {
  return [...getNavEntries(), ...SHELL_NAV_ENTRIES].sort(
    (a, b) => (a.order ?? 100) - (b.order ?? 100) || a.label.localeCompare(b.label),
  );
}
